import { UserPermissionsType as ApiUserPermissionType } from 'src/api/generated/auth/types';
import { mapPermissionActionType } from './helpers';
import { PermissionNameUnionType, UserPermissionType } from './types';

export const mapUserPermissionType = (
  apiPermission: ApiUserPermissionType
): UserPermissionType => {
  return {
    permission: apiPermission.permName as PermissionNameUnionType,
    action: mapPermissionActionType(apiPermission.rwd),
  };
};
